export default __webpack_public_path__ + "static/media/kamiq.d4350eb9.png";